import { useState } from 'react';
import PropTypes from 'prop-types';

import { TableRowCmp } from './table-row.styled';
import { OptionsCell, Cell } from 'libs/ui';

export const TableRow = (props) => {
  const { fields, row, actions, onRowClick, onRowClickCmp, onRowDblClick, getRowClass, theme, updateEntry, withCheck, select, withCheckChecked } = props;
  const [showAdditional, setShowAdditional] = useState(false);
  const fieldsOk = fields.filter((el) => !el.isHidden);

  /**
   * row click event
   * @param event
   */
  const handleClick = (event) => {
    // console.log("event", event.button);
    event.preventDefault();
    if (event.target.nodeName.toLowerCase() === 'td') {
      if (onRowClick) {
        onRowClick(row);
      }
      if (onRowClickCmp) {
        setShowAdditional((val) => !val);
      }
    }
  };

  /**
   * row dblclick event
   * @param {*} event 
   */
  const handleDblClick = (event) => {
    if (event.button === 1) {
      event.preventDefault();
      if (event.target.nodeName.toLowerCase() === 'td') {
        if (onRowDblClick) {
          onRowDblClick(row);
        }
      }
    }
  };

  /**
   * render cell value
   * @param val
   * @param field
   * @returns
   */
  const renderCell = (val, field, other, row) => {
    if (field.render) {
      return field.render(val, other, row);
    }
    // if (field.renderCmp) {
    //   const Cmp = field.renderCmp;
    //   return <Cmp row={row} />;
    // }
    return val;
  };

  // row optional params
  const params = {};
  if (onRowClick || onRowClickCmp || onRowDblClick) {
    params.onClick = (event) => handleClick(event);
  }
  if (onRowDblClick) {
    params.onMouseDown = (event) => handleDblClick(event);
  }

  if (getRowClass) {
    const rowClass = getRowClass(row);
    if (rowClass) {
      params.className = rowClass;
    }
  }

  const stopEvent = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const selectRow = (event) => {
    select(row, event.target.checked);
    stopEvent(event);
  };

  const AdditionalCmp = onRowClickCmp ? onRowClickCmp : null;
  const colCnt = (withCheck ? 1 : 0) + fieldsOk.length + (actions?.length ? 1 : 0);

  return (
    <>
      <TableRowCmp {...params} tabIndex={-1} theme={theme}>
        {withCheck && (
          <Cell theme={theme} title="Выбрать ряд" onClick={stopEvent}>
            <input type="checkbox" onChange={selectRow} checked={withCheckChecked} key={'selector' + withCheckChecked.toString()} />
          </Cell>
        )}
        {fieldsOk.map((field, idx) => {
          if (field.renderCell) {
            return field.render(
              row[field.name],
              {
                key: idx,
                align: field.align ? field.align : field.numeric ? 'right' : 'left',
                theme,
              },
              row,
            );
          }
          return (
            <Cell key={idx} number={field.numeric} align={field.align ? field.align : field.numeric ? 'right' : 'left'} theme={theme} clip={field.clip} width={field.width}>
              {renderCell(row[field.name], field, null, row)}
            </Cell>
          );
        })}

        {actions && actions.length > 0 && (
          <OptionsCell updateEntry={updateEntry} row={row} options={actions} disabled={actions.length === 0} left={-62} theme={theme}></OptionsCell>
        )}
      </TableRowCmp>
      {showAdditional && <AdditionalCmp cols={colCnt} row={row} close={() => setShowAdditional(false)} />}
    </>
  );
};

TableRow.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array,
  withCheck: PropTypes.bool,
  row: PropTypes.any.isRequired,
  onRowClick: PropTypes.func,
  onRowDblClick: PropTypes.func,
  onRowClickCmp: PropTypes.func,
  getRowClass: PropTypes.func,
  deleteAction: PropTypes.func,
  align: PropTypes.string,
  theme: PropTypes.string,
  select: PropTypes.func.isRequired,
  withCheckChecked: PropTypes.bool,
};
